import { ICruise } from "interfaces/ReduxState/ICruise";
import { CruisesActions } from "../actions/cruisesActions";

const initialState: ICruise = {
  cruiseDetails: [],
  cruiseStartDate: "",
  cruiseEndDate: "",
  cruiseHeaderImage: "",
};

const cruisesReducers = (state = initialState, action: CruisesActions) => {
  switch (action.type) {
    case "CLEAR_CRUISES":
      return initialState;

    case "SET_CRUISES":
      return {
        ...state,
        cruiseDetails: action.cruises,
        cruiseStartDate: action.cruiseStartDate,
        cruiseEndDate: action.cruiseEndDate,
      };

    case "SET_CRUISE_HEADER_IMAGE":
      return {
        ...state,
        cruiseHeaderImage: action.image,
      };

    default:
      return state;
  }
};

export default cruisesReducers;
